var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStopwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.044 5.333c-.266.001-.521-.105-.709-.293l-3.343-3.333c-.368-.394-.357-1.008.025-1.39.382-.38.997-.39 1.393-.024l3.343 3.334c.286.286.372.715.217 1.089-.155.373-.52.617-.926.617zM6.686 2.667C2.993 2.667 0 5.65 0 9.333 0 13.015 2.993 16 6.686 16s6.686-2.985 6.686-6.667c-.004-3.68-2.995-6.662-6.686-6.666zM10.03 10H6.686c-.37 0-.668-.298-.668-.667V6c0-.368.299-.667.668-.667.37 0 .669.299.669.667v2.667h2.674c.37 0 .669.298.669.666 0 .369-.3.667-.669.667z",
    transform: "translate(-897 -218) translate(498 141) matrix(-1 0 0 1 425 69) translate(0 .5) matrix(-1 0 0 1 26 8.5)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStopwatch);
export default __webpack_public_path__ + "static/media/icon_stopwatch.d80a74c325e29ea8d6ff478529ed6818.svg";
export { ForwardRef as ReactComponent };